export const FNM_ESTATE_OFFER = {
  agency: "First National Moreton",
  price: 1100,
  wills: 2,
  epoas: 2,
  gstIncluded: true,
} as const;